import { useState, useEffect } from "react";
import { useAuth, useCart, API } from "../App";
import axios from "axios";
import { toast } from "sonner";
import { Card } from "../components/ui/card";
import { Package } from "lucide-react";

export default function QuickPickItems() {
  const { getAuthHeader } = useAuth();
  const { addToCart } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuickPickProducts();
  }, []);

  const fetchQuickPickProducts = async () => {
    try {
      const response = await axios.get(`${API}/products/quick-pick`, getAuthHeader());
      setProducts(response.data);
    } catch (error) {
      toast.error("Failed to load quick pick items");
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="animate-fade-in" data-testid="quick-pick-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Quick Pick Items</h1>
        <span className="text-slate-500">{products.length} items</span>
      </div>

      {products.length === 0 ? (
        <Card className="p-12 text-center">
          <Package className="w-12 h-12 mx-auto text-slate-300 mb-4" />
          <p className="text-slate-500">No quick pick items configured</p>
          <p className="text-sm text-slate-400 mt-1">
            Add products and mark them as quick pick to see them here
          </p>
        </Card>
      ) : (
        <div className="quick-pick-grid">
          {products.map((product) => (
            <div
              key={product.id}
              onClick={() => handleAddToCart(product)}
              className="quick-pick-item cursor-pointer group"
              data-testid={`quick-pick-${product.id}`}
            >
              {product.image_url ? (
                <img
                  src={product.image_url}
                  alt={product.name}
                  className="w-full h-24 object-cover rounded-md mb-3"
                />
              ) : (
                <div className="w-full h-24 bg-slate-100 rounded-md mb-3 flex items-center justify-center">
                  <Package className="w-8 h-8 text-slate-300" />
                </div>
              )}
              <h3 className="font-semibold text-slate-800 text-sm line-clamp-2 group-hover:text-blue-600 transition-colors">
                {product.name}
              </h3>
              <p className="text-xs text-slate-500 mt-1">{product.category}</p>
              <p className="text-lg font-bold text-blue-600 mt-2">
                ${product.price.toFixed(2)}
              </p>
              <p className="text-xs text-slate-400 font-mono">#{product.barcode}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
